const isEmptyValue = (value: string) => value === ''

export const getValidValueBetweenMinMax = (
  value: string,
  minValue: number,
  maxValue: number
) => {
  if (isEmptyValue(value)) return undefined
  if (parseInt(value as string, 10) < minValue) return minValue
  if (parseInt(value as string, 10) >= maxValue) return maxValue
  return Number(value)
}

export const getValidValueBetweenMinMaxFloat = (
  value: string,
  minValue: number,
  maxValue: number
) => {
  if (isEmptyValue(value)) return undefined
  if (parseFloat(value as string) < minValue) return minValue
  if (parseFloat(value as string) >= maxValue) return maxValue
  return Number(value)
}

export const isNonEmptyNumber = (value?: number) => {
  const checkNumber = value === 0 ? 0 : value || NaN
  return !isNaN(checkNumber)
}
